import { useContext } from 'react';
import { AlertContext, AlertTextContext, AlertTypeContext, IsAlertOpenContext } from '../context';
export var useIsAlertOpen = function () { return useContext(IsAlertOpenContext); };
export var useAlertText = function () { return useContext(AlertTextContext); };
export var useAlertType = function () { return useContext(AlertTypeContext); };
export var useAlert = function () { return useContext(AlertContext); };
//# sourceMappingURL=alert-hooks.js.map